import React from "react";

/**
 * Casati Consulting mark — photographic CC monogram (brass on stone),
 * provided by the practice. Rendered as a square framed image.
 */
export function LogoMark({ size = 40 }) {
    return (
        <img
            src="/brand/cc-logo.png"
            alt="Casati Consulting"
            width={size}
            height={size}
            loading="eager"
            decoding="async"
            className="block object-cover"
            style={{
                width: size,
                height: size,
                borderRadius: 2,
            }}
        />
    );
}

export default function Logo({ inverted = false, className = "" }) {
    const ink = inverted ? "#F9F9F7" : "#1C1C1C";
    const accent = "#9B7A58";
    return (
        <div
            className={`flex items-center gap-3 ${className}`}
            data-testid="brand-logo"
        >
            <LogoMark size={40} />
            <div className="leading-tight">
                <div
                    className="font-display text-[15px] font-medium tracking-tight"
                    style={{ color: ink, letterSpacing: "-0.02em" }}
                >
                    Casati Consulting
                </div>
                <div
                    className="text-[10px] uppercase tracking-[0.22em] font-bold"
                    style={{ color: accent }}
                >
                    Zürich
                </div>
            </div>
        </div>
    );
}
